<template>
  <v-flex md4 xs12 class="column">
    <img :src="feature.image" alt="">
    <h2 class="title">{{feature.title}}</h2>
    <p class="text">{{feature.text}}</p>
  </v-flex>
</template>

<script>
    export default {
      props: ['feature'],
      name: 'Features',
    };
</script>

<style lang="scss" scoped>
  .content{
    margin-top: 90px;
  }
  .column{
    display: flex;
    flex-direction: column;
    align-items: center;
  .title{
    margin-top:25px;
    margin-bottom: 15px;
    font-family: Roboto;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-align: center;
    color: #4a4a4a;
  }
  .text{
    margin: 0 20px 100px;
    font-family: Roboto;
    font-size: 18px;
    font-weight: 300;
    line-height: 1.35;
    text-align: center;
    color: #4a4a4a;
  }
  }
</style>
